import { ReactElement } from 'react';

import { NextPage } from 'next';
import { LayoutAppProps } from 'next/app';

import Default from '@global-layouts/Default';

import { Toast } from '@global-components/Toast';
import MetaTags from '@global-components/Utils/MetaTags';

import { useToastStore } from '@global-stores/toast/useToast';

import QueryClientProvider from '@global-libs/react-query';

import '@global-libs/i18n';

import '@assets/fontawesome/css/font-awesome.min.css';
import '@global-styles/global.css';

const getLayoutDefault = (page: ReactElement): React.ReactElement => {
  return <Default>{page}</Default>;
};

const AppPage: NextPage<LayoutAppProps> = ({ Component, pageProps }): React.ReactElement => {
  const getLayout = Component.getLayout ?? getLayoutDefault;
  const { isOpen, title, message, type, dismiss } = useToastStore((state) => state);

  return (
    <QueryClientProvider dehydratedState={pageProps.dehydratedState}>
      <MetaTags />

      {getLayout(<Component {...pageProps} />)}
      <Toast
        isOpen={isOpen}
        title={title}
        message={message}
        type={type}
        autoClose
        onClose={() => dismiss()}
      />
    </QueryClientProvider>
  );
};

export default AppPage;
